module.exports = __webpack_public_path__ + "static/img/image1.77622594.png";